export const PartnershipsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <rect
        x="2.875"
        y="11.125"
        width="6"
        height="6"
        rx="0.75"
        stroke="currentColor"
      />
      <rect
        x="11.125"
        y="11.125"
        width="6"
        height="6"
        rx="0.75"
        stroke="currentColor"
      />
      <rect
        x="2.875"
        y="2.875"
        width="6"
        height="6"
        rx="0.75"
        stroke="currentColor"
      />
      <rect
        x="11.125"
        y="2.875"
        width="6"
        height="6"
        rx="0.75"
        stroke="currentColor"
      />
    </svg>
  );
};
